import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

import { useAppSelector } from "app/hooks";
import { HIDE_VISIT_NOTES_BY_ROLE_FEATURE } from "constants/feature-flags";
import { selectCurrentUser } from "features/auth/auth-slice";
import { canViewVisitNotes } from "utils/visit-note-visibility.util";

// ENG-2484: whether the current user may see visit-note content. True whenever the flag is off.
// Reads the store directly rather than useUserRoles(), which many suites mock with partial objects.
export default function useCanViewVisitNotes(): boolean {
  const flags = useFlags();
  const isFeatureOn = Boolean(flags[HIDE_VISIT_NOTES_BY_ROLE_FEATURE]);
  const groups = useAppSelector(selectCurrentUser)?.groups;

  return useMemo(
    () =>
      canViewVisitNotes(
        isFeatureOn,
        (groups ?? []).map(({ name }) => name)
      ),
    [isFeatureOn, groups]
  );
}
